import React from 'react';
import {
  Box,
  BoxProps,
  createStyles,
  Theme,
  withStyles,
  TableBodyProps,
} from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';

export const RowBox = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      transition: 'background-color 0.3s linear',
      padding: spacing(1),
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)((props: BoxProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    {...props}
  />
));

export const CustomTableBody = withStyles(() =>
  createStyles({
    root: {
      transition: 'box-shadow 0.3s linear',
      borderRadius: 10,
      paddingBottom: 10,
    },
  })
)((props: TableBodyProps) => <TableBody {...props} />);

export const CategoryName = withStyles(() => createStyles({}))((props) => (
  <FsBodySmallBold component="h5" {...props} />
));

export const Value = withStyles(() =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  })
)((props) => <FsBody component="span" {...props} />);

export const LastValue = withStyles(() =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  })
)((props) => <FsBodyBold component="span" {...props} />);

export const LastValueBox = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      borderLeft: `1px solid ${palette.grey[200]}`,
      minWidth: 100,
      display: 'flex',
      justifyContent: 'center',
      marginLeft: spacing(2),
    },
  })
)((props: BoxProps) => <Box {...props} />);
